/**
 * Suivi d'une notification de note dans la cloche « Notifications et rappels ».
 *
 * « Me le rappeler » acquitte la notification (elle ne compte plus dans le
 * badge) et crée un rappel personnel dont `sourceRef` pointe vers elle. Tant
 * que ce rappel est ouvert et que la notification n'a pas été convertie en
 * tâche d'équipe, la cloche la garde pour proposer « Convertir en tâche
 * d'équipe ». La conversion est notée sur le rappel (`convertedToTaskAt`),
 * les règles n'autorisant sur `noteNotifications` que l'acquittement.
 */
export const NOTE_NOTIFICATION_SOURCE = "noteNotification";

export const sourceNotificationId = (activity) =>
  activity &&
  activity.sourceRef &&
  activity.sourceRef.type === NOTE_NOTIFICATION_SOURCE
    ? activity.sourceRef.id || null
    : null;

export const isActivityConvertedToTask = (activity) =>
  Boolean(activity && (activity.convertedToTaskAt || activity.convertedToTaskAtUnix));

/**
 * Lignes de notifications de la cloche : non lues d'abord, puis celles
 * acquittées par un rappel encore ouvert et pas encore converties.
 * @param {Array<Object>} notifications - documents `noteNotifications`
 * @param {Array<Object>} activities - rappels de l'utilisateur
 * @param {number} limit
 * @returns {Array<{notification: Object, hasOpenReminder: boolean, canConvertToTask: boolean}>}
 */
export function buildBellNotificationRows(notifications = [], activities = [], limit = 8) {
  const withOpenReminder = new Set();
  const converted = new Set();
  (activities || []).forEach((activity) => {
    const id = sourceNotificationId(activity);
    if (!id) return;
    if (isActivityConvertedToTask(activity)) converted.add(id);
    if (activity.status === "open") withOpenReminder.add(id);
  });

  const list = notifications || [];
  const unread = list.filter((n) => n.status !== "acknowledged");
  const followed = list.filter(
    (n) =>
      n.status === "acknowledged" &&
      withOpenReminder.has(n.id) &&
      !converted.has(n.id)
  );

  return [...unread, ...followed].slice(0, limit).map((notification) => ({
    notification,
    hasOpenReminder: withOpenReminder.has(notification.id),
    canConvertToTask: !converted.has(notification.id),
  }));
}

export default buildBellNotificationRows;
